import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { ONBOARDING_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IOnboardingQuestionnaireReferralInfo } from '../../../../../pages/questionnaires/onboarding/components/forms/referral/types';
import type { UpdateOnboardingQuestionnaireReferralInfoPayload } from './types';

export function createOnboardingReferralThunks() {
  return {
    updateOnboardingQuestionnaireReferralInfo: updateOnboardingQuestionnaireReferralInfo(),
  };
}

function updateOnboardingQuestionnaireReferralInfo() {
  return createAsyncThunk<
    IOnboardingQuestionnaireReferralInfo,
    UpdateOnboardingQuestionnaireReferralInfoPayload
  >(
    'onboardingQuestionnaire/updateOnboardingQuestionnaireReferralInfo',
    async ({ onboardingQuestionnaireId, data, getAccessTokenSilently }) => {
      const response: IOnboardingQuestionnaireReferralInfo = await fetchWrapper.patch(
        {
          url: `${ONBOARDING_QUESTIONNAIRES_API_BASE}/${onboardingQuestionnaireId}/referral`,
          getAccessTokenSilently,
        },
        data,
      );
      return response;
    },
  );
}
